import {defineElement, html, TemplateElement} from '@webtides/element-js';
import { responsiveImage } from '../../../../directives/images.js';

/**
 * @property {string} headline

 */
export default class IconList extends TemplateElement {

    properties() {
        return {
            headline:'',
            list: {}
        };
    }

    template() {
        return html`
            <h2 class="text-xl font-medium text-green-medium mb-8">${this.headline}</h2>
            <ul>
                ${this.list.map(
                    (item) => html`
                        <li class="flex items-center py-12">
                            <span class="max-w-40 mr-16">
                                ${responsiveImage(
                                    item.icon,
                                    '',
                                    false
                                )}
                            </span>
                            <span class="text-base font-medium">${item.text}</span>
                        </li>
                        `,
                )}
            </ul>
        `;
    }

}

defineElement('mb-e-banking-icon-list', IconList);
